import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import React, { useEffect, useState } from "react"
import { Row, Col, Alert, Container, Input } from "reactstrap"
import { useSelector, useDispatch } from "react-redux"
import { withRouter, Link, useHistory } from "react-router-dom"


import {
  divisionDropdownSelectSuccess,
  getUserDetailsAction,
  loginError_Action,
  loginSuccessAction,
  loginUser,
  resetRoleAccessAction,
} from "../../store/actions"
import CarouselPage from "./CarouselPage"
import { useLayoutEffect } from "react"
import { afterloginOneTimeAPI } from "../../components/Common/AfterLoginApiFunc"
import { useSession } from "../../routes/middleware/SessionContext"
import { GET_COMPANY_FROM_URL, GET_ERP_IMG, saveLogoToLocalStorage, WITH_COMPANY_PATH, } from "../../components/Common/CommonFunction"
import Captcha, { generateCaptcha } from "./Captcha"
import { PartySettingBasicAuthApi } from "../../helpers/backend_helper"
import { isTokenExpired, showToastAlert } from "../../helpers/axios_Config"



const Login = props => {

  const dispatch = useDispatch()

  const history = useHistory()

  const [currentUserName, setcurrentUserName] = useState("");
  const [Password, setPassword] = useState("");
  const [IsLogin, setIsLogin] = useState(false);
  const [captchaCode, setCaptchaCode] = useState(generateCaptcha());
  const [captchaInput, setCaptchaInput] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const Company = GET_COMPANY_FROM_URL();
  const refreshCaptcha = () => {
    setCaptchaCode(generateCaptcha());
    setCaptchaInput("");
  };
  const { loginError, loginSuccess, divisionDropdown_redux = [], userAccess, loading } = useSelector(state => ({
    loading: state.Login.loading,
    loginError: state.Login.loginError,
    loginSuccess: state.Login.loginSuccess,
    divisionDropdown_redux: state.Login.divisionDropdown,
    userAccess: state.Login.RoleAccessUpdateData,
  }))
  const { session, updateSessionActivity } = useSession();
  const getCachedCaptcha = () => {
    if (Company === "Default") return false;

    // value saved from the last PartySetting API call (survives logout, since you keep _LoginCaptcha)
    const cached = localStorage.getItem(`${Company}_LoginCaptcha`);
    if (cached !== null) return Number(cached) === 1;

    // fallback: company theme
    try {
      const theme = JSON.parse(localStorage.getItem(`${Company}_companyTheme`));
      const fromTheme = theme?.Captcha;
      if (fromTheme !== undefined && fromTheme !== null) return Number(fromTheme) === 1;
    } catch (e) { }

    return false; // safe default until the API answers
  };
  //Captcha
  const [isCaptchaEnabled, setIsCaptchaEnabled] = useState(getCachedCaptcha);

  useEffect(() => {
    if (Company === "Default") return;

    const companyID = localStorage.getItem(`${Company}_companyID`);
    if (!companyID) return;

    let cancelled = false;

    (async () => {
      try {
        const res = await PartySettingBasicAuthApi(0, companyID);

        const list = res?.Data ?? res?.data?.Data;
        if (!Array.isArray(list)) return; // bad response: keep cached value

        const setting = list.find(
          i => i.SystemSetting?.trim() === "Captcha" && i.IsActive
        );

        // API worked: missing or not "1" means captcha is off
        const enabled = String(setting?.Value ?? "0").trim() === "1";

        localStorage.setItem(`${Company}_LoginCaptcha`, enabled ? 1 : 0);
        if (!cancelled) setIsCaptchaEnabled(enabled);
      } catch (e) {
        // API failed: keep cached value
      }
    })();

    return () => { cancelled = true; };
  }, [Company]);

  useLayoutEffect(() => {

    dispatch(resetRoleAccessAction())
    dispatch(divisionDropdownSelectSuccess([]))
  }, []);

  useEffect(() => {
    saveLogoToLocalStorage();
  }, []);


  useLayoutEffect(() => {
    try {
      // first lines inside the try of the first useLayoutEffect
      const token = localStorage.getItem(`${Company}_token`);
      const refreshToken = localStorage.getItem(`${Company}_refreshToken`);
      const expiredFlag = sessionStorage.getItem("sessionExpiredMsg");
      const tokensDead = token && isTokenExpired(token) && (!refreshToken || isTokenExpired(refreshToken));

      if (tokensDead || expiredFlag) {
        sessionStorage.removeItem("sessionExpiredMsg");
        showToastAlert("Your session has expired. Please log in again.", "error")
        localStorage.removeItem(`${Company}_token`)
        localStorage.removeItem(`${Company}_refreshToken`)
        updateSessionActivity({ active: false });
        document.getElementById("UserName")?.focus();
        return;
      }

      let forceReload = sessionStorage.getItem("foreceReload");
      if (forceReload && forceReload !== "false") {
        sessionStorage.setItem("foreceReload", false)
        window.location.reload(true);
      }
      if ((session.active === true && (localStorage.getItem(`${Company}_token`)) && (localStorage.getItem(`${Company}_roleId`)))) {


        const path = localStorage.getItem(`${Company}_LOGIN_REDIRECT`)
        if (path !== null) {
          history.push({ pathname: path })
        }

        return
      }
      document.getElementById("UserName").focus();
    } catch (e) { }
  }, [])






  useEffect(() => {
    try {
      if ((loginSuccess.Status === true) && (loginSuccess.StatusCode === 200)) {

        if (!loginSuccess.IsLoginPermissions) {
          setIsLogin(true)
          return dispatch(loginError_Action("Access Denied"))
        }
        updateSessionActivity({ active: true });
        localStorage.setItem(`${Company}_token`, (loginSuccess.token))
        localStorage.setItem(`${Company}_refreshToken`, (loginSuccess.refreshtoken))
        localStorage.setItem(`${Company}_userId`, (loginSuccess.UserID))

        localStorage.setItem(`${Company}_UserName`, (loginSuccess.UserDetails.UserName))
        localStorage.setItem(`${Company}_Company`, loginSuccess.UserDetails.CompanyID)
        localStorage.setItem(`${Company}_CompanyName`, loginSuccess.UserDetails.CompanyName)
        localStorage.setItem(`${Company}_CompanyGroup`, loginSuccess.UserDetails.CompanyGroup)
        localStorage.setItem(`${Company}_EmployeeID`, loginSuccess.UserDetails.EmployeeID)
        localStorage.setItem(`${Company}_EmployeeName`, loginSuccess.UserDetails.EmployeeName)
        if (loginSuccess.UserDetails.IsSCMCompany) {
          localStorage.setItem(`${Company}_IsSCMCompany`, 1)
        }
        else {
          localStorage.setItem(`${Company}_IsSCMCompany`, 0)
        }
        sessionStorage.setItem("foreceReload", Date.now())

        localStorage.setItem(`${Company}_LoginUserParties`, JSON.stringify(loginSuccess.UserParties || []))
        if (loginSuccess.UserParties.length === 1) {
          let user = loginSuccess.UserParties[0];

          if (user.Party_id === null) {
            user.Party_id = 0;
          }
          if ((localStorage.getItem(`${Company}_token`))) {
            afterloginOneTimeAPI(user, dispatch);// all common function
          }
        }
        else if (loginSuccess.UserParties.length > 1) {
          history.push("/division");
        }

        // dispatch(loginSuccessAction({ Status: false }))
        // dispatch(getUserDetailsAction(loginSuccess.UserID))

      }
    } catch (e) { }
  }, [loginSuccess])

  // useEffect(() => {

  //   if (divisionDropdown_redux.length === 1) {
  //     let user = divisionDropdown_redux[0];
  //     if (user.Party_id === null) {
  //       user.Party_id = 0;
  //     }

  //     if (session.active === true && (localStorage.getItem(`${Company}_token`))) {

  //       afterloginOneTimeAPI(user, dispatch);// all common function
  //     }
  //   }
  //   else if (divisionDropdown_redux.length > 1) {
  //     history.push("/division");
  //   }
  // }, [divisionDropdown_redux]);

  useEffect(() => {
    let dashboardFound = userAccess.find((i) => i.ModuleName === "Dashboard");

    if (loginSuccess?.UserParties?.length === 1 && userAccess.length > 1) {
      if (dashboardFound) {

        const redirectPath = `${(`/${dashboardFound.ActualPagePath}`)}`; // or your dynamic logic
        localStorage.setItem(
          `${Company}_LOGIN_REDIRECT`,
          redirectPath
        );
        history.push(`/${dashboardFound.ActualPagePath}`);

      } else {
        const redirectPath = `/Dashboard`; // or your dynamic logic
        localStorage.setItem(
          `${Company}_LOGIN_REDIRECT`,
          redirectPath
        );
        history.push("/Dashboard");
      }
    }


    // if (localStorage.getItem(`${Company}_LOGIN_REDIRECT`)) {
    //   history.push(localStorage.getItem(`${Company}_LOGIN_REDIRECT`));
    // }

  }, [userAccess]);

  useEffect(() => {
    if (
      window.location.hostname === "cbmfooderp.com" ||
      window.location.hostname === "www.cbmfooderp.com"
    ) {
      const script = document.createElement("script");
      script.src =
        "https://seal.starfieldtech.com/getSealPremium?sealID=wmaKVl3WJYXS6VHdTuwJYzyMedef43vKWgAxcfqfPBGNZRkaZM5GKF9Ex7ot";
      script.async = true;

      document.getElementById("siteseal")?.appendChild(script);
    }
  }, []);

  useEffect(() => {
    if (loginError) refreshCaptcha();
  }, [loginError]);

  const currentUserOnchange = (e) => {
    setcurrentUserName(e.target.value)
    dispatch(loginError_Action(null))
  }

  const PasswordOnchange = (e) => {
    setPassword(e.target.value)
    dispatch(loginError_Action(null))
  }

  const SaveHandler = async (event) => {
    event.preventDefault();

    if (currentUserName === "" && Password === "") {
      dispatch(loginError_Action("Invalid UserName and Password"))
      return
    }
    if (currentUserName === "") {
      dispatch(loginError_Action("Invalid UserName"))
      return
    }
    if (Password === "") {
      dispatch(loginError_Action("Incorrect Password"))
      return
    }
    if (isCaptchaEnabled && captchaInput.trim() !== captchaCode) {
      dispatch(loginError_Action("Invalid Captcha"))
      return
    }

    const values = {
      UserName: currentUserName,
      Password: Password,
      CompanyId: localStorage.getItem(`${Company}_companyID`)
    }
    dispatch(loginUser(values, props.history))
  };

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };
  function handleKeyDown({ event, Type }) {
    // Check if the pressed key is a space
    if (event.key === " ") {
      // Check if the input contains only spaces
      if (event.target.value.trim() === "") {
        // Prevent default behavior (typing space)
        event.preventDefault();
      }
    }
  }

  return (
    <React.Fragment>
      <MetaTags>
        <title>Login | FoodERP 2.0</title>
      </MetaTags>
      <div className="auth-page">
        <Container fluid className="p-0">

          <Row className="g-0">
            <Col lg={4} md={5} className="col-xxl-3">
              <div className="auth-full-page-content d-flex p-sm-5 p-4">
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <div className="mb-4 md-5 text-center">
                      <div style={{ cursor: "context-menu" }} className="logo logo-dark">
                        <span className="logo-txt">FoodERP 2.0</span>
                      </div>

                      {/* ✅ Centered logo box */}
                      <div
                        style={{
                          width: "100%",
                          height: "140px",
                          display: "flex",

                          justifyContent: "center",
                          alignItems: "center"
                        }}
                      >
                        <img
                          src={GET_ERP_IMG().Logo}
                          alt="Logo"
                          style={{
                            maxWidth: "100%",
                            maxHeight: "100%",
                            borderRadius: "10px",
                            objectFit: "contain" // ✅ keeps full logo visible
                          }}
                        />
                      </div>

                      {IsLogin && (
                        <Col lg={12}>
                          <div className="text-center">
                            <div className="pt-4">
                              <i className="mdi mdi-account-cancel display-3 text-danger"></i>
                            </div>
                            <h3 className="mt-4">Access Denied</h3>
                            <p>Your account is not authorized. Please contact support.</p>
                          </div>
                        </Col>
                      )}
                    </div>

                    <div className="auth-content my-auto">
                      <div style={{ cursor: "context-menu" }} className="text-center">
                        <h5 className="mb-0">Welcome</h5>
                        <p className="text-muted mt-2">Sign in to Continue FoodERP 2.0</p>
                      </div>
                      {loginError ? (
                        <Alert color="danger" style={{ marginTop: "13px" }}>
                          {loginError}
                        </Alert>
                      ) : null}
                      <form>
                        <div className="mb-3">
                          <div className="d-flex align-items-start">
                            <div className="flex-grow-1">
                              <label className="form-label">User Name</label>
                            </div>
                          </div>

                          <div className="mb-3">
                            <Input
                              name="UserName"
                              id="UserName"
                              type="text"
                              value={currentUserName}
                              autoComplete="off"
                              autoFocus={false}
                              onKeyDown={(event) => {
                                handleKeyDown({ event: event, Type: "UserName" });
                              }}
                              required
                              onChange={currentUserOnchange}
                              placeholder="Enter User Name"
                            />
                          </div>
                        </div>

                        <div className="mb-3">
                          <div className="d-flex align-items-start">
                            <div className="flex-grow-1">
                              <label className="form-label">Password</label>
                            </div>
                          </div>

                          <div className="mb-3">
                            <div className="input-group">
                              <Input
                                name="Password"
                                value={Password}
                                autoComplete="off"
                                onChange={PasswordOnchange}
                                type={showPassword ? "text" : "password"}
                                className="form-control"
                                onKeyDown={(event) => {
                                  handleKeyDown({ event: event, Type: "Password" });
                                }}
                                required
                                placeholder="Enter Password"
                              />
                              <button
                                className="btn btn-outline-primary"
                                style={{ borderColor: "#d4d4d4" }}
                                type="button"
                                onClick={toggleShowPassword}
                              >
                                {showPassword ? (
                                  <i className="mdi mdi-eye-off"></i>
                                ) : (
                                  <i className="mdi mdi-eye"></i>
                                )}
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className=" mb-4">
                          <Link to="/forgot-password" className="fw-semibold">
                            Forgot password?
                          </Link>
                        </div>
                        {isCaptchaEnabled && (
                          <div className="mb-3">
                            <Captcha code={captchaCode} onRefresh={refreshCaptcha} />
                            <Input
                              className="mt-2"
                              type="text"
                              value={captchaInput}
                              autoComplete="off"
                              placeholder="Enter captcha"
                              onChange={(e) => {
                                setCaptchaInput(e.target.value);
                                dispatch(loginError_Action(null));
                              }}
                            />
                          </div>
                        )}
                        <div className="mb-3">
                          {loading ? (
                            <button
                              className="btn btn-primary w-100 waves-effect waves-light"
                              autoFocus
                              type="button"
                            >
                              <div className="dot-pulse">
                                {" "}
                                <span> Login</span> &nbsp;
                                <div className="bounce1" style={{ background: "white" }}></div>
                                <div className="bounce2" style={{ background: "white" }}></div>
                                <div className="bounce3" style={{ background: "white" }}></div>
                              </div>{" "}
                            </button>
                          ) : (
                            <button
                              className="btn btn-primary w-100 waves-effect waves-light"
                              autoFocus
                              type="submit"
                              id="loginbtn"
                              onClick={SaveHandler}
                            >
                              Login
                            </button>
                          )}
                        </div>
                      </form>
                    </div>

                    <div className="mt-4 mt-md-5 text-center">
                      <p
                        style={{ cursor: "context-menu" }}
                        className="mb-0"
                      >
                        © {new Date().getFullYear()}.Developed by Attrib Solution
                      </p>
                      {
                        <div
                          className="mt-2"
                          style={{
                            transform: "scale(0.7)",
                            transformOrigin: "center",
                          }}
                        >
                          <span id="siteseal"></span>
                        </div>
                      }
                    </div>
                  </div>
                </div>

              </div>
            </Col>
            <CarouselPage />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Login)

Login.propTypes = {
  history: PropTypes.object,
}
